import { useTranslation } from 'react-i18next'

import { Checkbox, ChipInput } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const TagsSelector = ({ label, tags, onChangeTags, matchCase, onChangeMatchCase }) => {
  const { t } = useTranslation()

  const handleChangeMatchCase = e => {
    onChangeMatchCase(e.target.checked)
  }

  return (
    <Styles.Container>
      <ChipInput label={label || t('Etiquetas de producto')} value={tags} onChange={onChangeTags} />
      <Checkbox label={t('Distinguir mayúsculas y minúsculas')} checked={matchCase} onChange={handleChangeMatchCase} />
    </Styles.Container>
  )
}

export default TagsSelector
